export default "__VITE_PUBLIC_ASSET__7ac43703__"